import ReactGA from 'react-ga4';
import Button from '../components/Button';
import '../styles/pages/page.scss';
import '../styles/pages/products.scss'

const Products = () => (
    <div className="page-container">
        <div className="main-container">
            <h1 className="main-title">
                Products
            </h1>
            <h1 className="product-title">
                Limited Edition available for:
            </h1>
            <h1 className="product-title red">
                Nintendo Switch™
            </h1>
            <div className="product-pair">
                <img src="./img/products/le-nsw.jpg" alt="Yomawari Limited Edition Nintendo Switch™" className='product-image'/>
                <ul className="product-list">
                    <li>
                        <a href="https://store.nisamerica.com/yomawari-lost-in-the-dark/yomawari-lost-in-the-dark-limited-edition-nintendo-switch" target="_blank" rel="noopener noreferrer">
                            <Button text="NISA ONLINE STORE" color="red" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `LE - NSW - NISA ONILNE`
                                })}
                            }/>
                        </a>
                    </li>
                </ul>            
            </div>
            <h1 className="product-title blue">
                PlayStation®4
            </h1>
            <div className="product-pair">
                <img src="./img/products/le-ps4.jpg" alt="Yomawari Limited Edition PlayStation®4" className='product-image'/>
                <ul className="product-list">
                    <li>
                        <a href="https://store.nisamerica.com/yomawari-lost-in-the-dark/yomawari-lost-in-the-dark-limited-edition-ps4" target="_blank" rel="noopener noreferrer">
                            <Button text="NISA ONLINE STORE" color="blue" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `LE - PS4 - NISA ONILNE`,
                                })}
                            }/>
                        </a>
                    </li>
                </ul>            
            </div>
            <h1 className="product-title">
                Deluxe Edition available for:
            </h1>
            <h1 className="product-title red">
                Nintendo Switch™
            </h1>
            <div className="product-pair">
                <img src="./img/products/de-nsw.jpg" alt="Yomawari Deluxe Edition Nintendo Switch™" className='product-image'/>
                <ul className="product-list">
                    <li>
                        <a href="https://www.amazon.com/Yomawari-Lost-Dark-Deluxe-Nintendo-Switch/dp/B0B4PS3PJK" target="_blank" rel="noopener noreferrer">
                            <Button text="Amazon" color="red" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Amazon`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.amazon.ca/Yomawari-Lost-Deluxe-Nintendo-Switch/dp/B0B4PS3PJK/" target="_blank" rel="noopener noreferrer">
                            <Button text="Amazon (CA)" color="red" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Amazon (CA)`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bestbuy.com/site/yomawari-lost-in-the-dark-deluxe-edition-nintendo-switch/6514244.p?skuId=6514244" target="_blank" rel="noopener noreferrer">
                            <Button text="Best Buy" color="red" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Best Buy`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.gamestop.com/video-games/products/yomawari-lost-in-the-dark-deluxe-edition---nintendo-switch/345358.html" target="_blank" rel="noopener noreferrer">
                            <Button text="Gamestop" color="red" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Gamestop`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.gamestop.ca/Switch/Games/897554/yomawari-lost-in-the-dark-deluxe-edition" target="_blank" rel="noopener noreferrer">
                            <Button text="Gamestop (CA)" color="red" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - NSW - Gamestop (CA)`
                                })}
                            }/>
                        </a>
                    </li>
                </ul>            
            </div>
            <h1 className="product-title blue">
                PlayStation®4
            </h1>
            <div className="product-pair">
                <img src="./img/products/de-ps4.jpg" alt="Yomawari Deluxe Edition PlayStation®4" className='product-image'/>
                <ul className="product-list">
                    <li>
                        <a href="https://www.amazon.com/Yomawari-Lost-Dark-Deluxe-PlayStation-4/dp/B0B4QNJDCD" target="_blank" rel="noopener noreferrer">
                            <Button text="Amazon" color="blue" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Amazon`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.amazon.ca/Yomawari-Lost-Dark-Deluxe-Playstation/dp/B0B4QNJDCD/" target="_blank" rel="noopener noreferrer">
                            <Button text="Amazon (CA)" color="blue" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Amazon (CA)`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bestbuy.com/site/yomawari-lost-in-the-dark-deluxe-edition-playstation-4/6514247.p?skuId=6514247" target="_blank" rel="noopener noreferrer">
                            <Button text="Best Buy" color="blue" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Best Buy`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.gamestop.com/video-games/products/yomawari-lost-in-the-dark-deluxe-edition---playstation-4/345360.html" target="_blank" rel="noopener noreferrer">
                            <Button text="Gamestop" color="blue" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Gamestop`
                                })}
                            }/>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.gamestop.ca/PS4/Games/897553/yomawari-lost-in-the-dark-deluxe-edition" target="_blank" rel="noopener noreferrer">
                            <Button text="Gamestop (CA)" color="blue" onClick={
                                ()=>{
                                    ReactGA.event({
                                    category: 'Product Link',
                                    action: 'Click',
                                    label: `DE - PS4 - Gamestop (CA)`
                                })}
                            }/>
                        </a>
                    </li>
                </ul>            
            </div>
            <h1 className="product-title red">
                Available on Steam
            </h1>
            <iframe src="https://store.steampowered.com/widget/1998330/" frameborder="0" style={{maxWidth: '650px'}}width="100%" height="190"></iframe>        
        </div>
    </div>
)

export default Products;